const TEMPLATE_T1 = 'T1';
const TEMPLATE_T2 = 'T2';
const FORMAT_DATE = 'DD/MM/YYYY';
const FORMAT_DATETIME = 'DD/MM/YYYY HH:mm';
const REGEX_TEXT = /^[a-zA-ZÀ-ÿ\s]+$/i;
const REGEX_ALPHA_NUMERIC = /^[a-zA-Z0-9À-ÿ\s]+$/i;
const REGEX_CAP = /^[0-9]{5}$/i;
const REGEX_MAIL = "^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$";
const REGEX_PHONE = "^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$";



export function makeValidationFunction(type: 'CAP' | 'TEXT' | 'EMAIL' | 'PHONE' | 'PROVINCE') {
    let regex = '';

    if (type == 'PROVINCE') { regex = "^[A-Za-z]{2}$" };
    if (type == 'CAP') { regex = "^[0-9]{5}$" };
    if (type == 'TEXT') { regex = "^[a-zA-ZÀ-ÿ\s]+$" };
    if (type == 'EMAIL') { regex = REGEX_MAIL };
    if (type == 'PHONE') { regex = "^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$" };

    return btoa(`(function val(param) {
        const regex = "${regex}"
        return !!param.value.match(regex);
    })`);
}
export const EMAIL_BASE64_VALIDATION_FUNCTION = 'KGZ1bmN0aW9uIHZhbChwYXJhbSkgew0KICB2YXIgcmVnZXggPSAvXigoW148PigpW1xdXC4sOzpcc0BcIl0rKFwuW148PigpW1xdXC4sOzpcc0BcIl0rKSopfChcIi4rXCIpKUAoKFtePD4oKVtcXVwuLDs6XHNAXCJdK1wuKStbXjw+KClbXF1cLiw7OlxzQFwiXXsyLH0pJC9pOw0KICB2YXIgbWF0Y2hpbmdQYXR0ZXJucyA9IHJlZ2V4LmV4ZWMocGFyYW0udmFsdWUpOw0KICByZXR1cm4gISFtYXRjaGluZ1BhdHRlcm5zICYmIG1hdGNoaW5nUGF0dGVybnMubGVuZ3RoID4gMDsNCn0p'
export {
    FORMAT_DATE,
    FORMAT_DATETIME, REGEX_ALPHA_NUMERIC, REGEX_CAP, REGEX_MAIL, REGEX_PHONE, REGEX_TEXT, TEMPLATE_T1,
    TEMPLATE_T2
};


export const STATIC_TRANSLATIONS = {
    REDEMPTION_FORM_ERROR: "REDEMPTION_FORM_ERROR",
    REDEMPTION_FIELDS_APPROVAL_ERROR: "REDEMPTION_FIELDS_APPROVAL_ERROR"
}